import React from 'react';

/**
 * ログアウトコンポーネント
 */
const Logout = () => {
  window.location.href = '/';
  return (
    <div>
    </div>
  );
};

export default Logout;
